export const UI_TEMPLATE_TYPE = {
  'ui_template_type_l_model': 'ui_template_type_l_model'
};